// extracted by mini-css-extract-plugin
export default {"dialog":"FilterPreconfigDialog_dialog__wbNft","titleTag":"FilterPreconfigDialog_titleTag__dvZ1U"};